import { render } from "./PracticePrefencesReadOnly.vue?vue&type=template&id=50ac463b&scoped=true"
import script from "./PracticePrefencesReadOnly.vue?vue&type=script&lang=js"
export * from "./PracticePrefencesReadOnly.vue?vue&type=script&lang=js"

import "./PracticePrefencesReadOnly.vue?vue&type=style&index=0&id=50ac463b&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ac463b"]])

export default __exports__